export interface Color {
  _id: string;
  name: string;
  hex?: string;
  image_url?: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
}

export interface ColorResponse {
  status: string;
  data: Color[];
}

export const colorService = {
  async getColors(): Promise<ColorResponse> {
    const response = await fetch('https://api.desilk.com.vn/api/v1/colors', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch colors');
    }

    return response.json();
  },
};
